import React, { Component, Fragment } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import _ from 'lodash';
import { CheckboxField } from 'Common/SemanticWrapper';

class CheckboxListComponent extends Component {
  static propTypes = {
    showAll: PropTypes.bool,
    title: PropTypes.string,
    displayItems: PropTypes.array.isRequired,
  };

  static defaultProps = {
    /**
     * @param {[String]} selectedItems
     */
    showAll: true,
    title: '',
  };

  state = {
    items: this.props.displayItems.map(value => ({ ...value })),
  };

  areAllChecked() {
    return _.every(this.state.items, { checked: true });
  }

  toggleAll(data) {
    this.state.items.forEach(x => {
      this.updateItem(x, data);
    });
  }

  updateItem(value, checked) {
    const { items } = this.state;
    const item = _.find(items, x => {
      return x.name === value.name;
    });

    if (item !== undefined) {
      item.checked = checked;
      this.props.change(item.name, item.checked);
    }

    this.setState({ items });
  }

  colWidth = () => {
    const { items } = this.state;

    if (items === undefined) return 1;

    return Math.floor(16 / (items.length + 1));
  };

  renderAll() {
    if (!this.props.showAll) return undefined;
    return (
      <Grid.Column width={this.colWidth()}>
        <Field
          component={CheckboxField}
          label={'All'}
          name={'All'}
          onChange={(e, data) => this.toggleAll(data)}
          checked={this.areAllChecked()}
        />
      </Grid.Column>
    );
  }

  render() {
    const { items } = this.state;

    if (items === undefined) return null;

    return (
      <Fragment>
        {this.renderAll()}
        {this.state.items.map((item, index) => {
          return (
            <Grid.Column width={this.colWidth()} key={index}>
              <Field
                component={CheckboxField}
                {...item}
                onChange={(e, data) => {
                  this.updateItem(item, data);
                }}
              />
            </Grid.Column>
          );
        })}
      </Fragment>
    );
  }
}

export default CheckboxListComponent;



// WEBPACK FOOTER //
// ./src/common/CheckboxListComponent.js